import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/jobTrackingTemplate`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/jobTrackingTemplate`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/${jobId}/jobTrackingTemplate`;
